"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analyticsMiddleware = void 0;

var _actionTypes = require("./action-types");

var _analyticEvents = require("./analytic-events");

var analyticsMiddleware = function analyticsMiddleware(state) {
  return function (next) {
    return function (action) {
      var type = action.type;

      switch (type) {
        case _actionTypes.GET_ACCOUNT_INFO_FULFILLED:
          (0, _analyticEvents.trackAnalytics)();
          break;

        case '@@router/LOCATION_CHANGE':
          (0, _analyticEvents.trackAnalytics)();
          break;

        default:
          break;
      } // continue


      next(action);
    };
  };
};

exports.analyticsMiddleware = analyticsMiddleware;